import {
    HStack,
    Avatar,
    Box,
    Text,
    Tag,
    Flex,
    Icon,
} from "@chakra-ui/react"
import { getGravatarUrl } from "../../utils/gravatar";


function UserCard({ user, machines, swipeInTime }) {
    const now = Math.floor(Date.now() / 1000);
    const then = Math.floor(swipeInTime.getTime() / 1000);
    const diff = now - then;
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const time = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

    return (
        <Box
            bg="white"
            rounded={{ base: "lg", xl: "xl" }}
            p={{ base: 3, md: 4, xl: 5 }}
            shadow="sm"
            borderWidth="1px"
            borderColor="gray.100"
            sx={{
                "@media (min-width: 120em)": { padding: "28px", borderRadius: "16px" },
            }}
        >
            <HStack
                spacing={{ base: 2.5, md: 3 }}
                mb={{ base: 2.5, md: 3, xl: 4 }}
            >
                <Avatar
                    size="md"
                    name={`${user.firstName} ${user.lastName}`}
                    src={getGravatarUrl(user.email)}
                    bg="brand.red"
                    color="white"
                    sx={{
                        "@media (min-width: 120em)": {
                            width: "64px",
                            height: "64px",
                            fontSize: "1.5rem",
                        },
                    }}
                />
                <Box minW={0} flex={1}>
                    <Text
                        fontWeight={600}
                        fontSize={{ base: "sm", md: "md" }}
                        color="gray.800"
                        lineHeight="short"
                        isTruncated
                        sx={{
                            "@media (min-width: 120em)": { fontSize: "22px" },
                        }}
                    >
                        {user.firstName} {user.lastName}
                    </Text>
                    <HStack
                        spacing={1}
                        color="gray.500"
                        fontSize="xs"
                        sx={{
                            "@media (min-width: 120em)": { fontSize: "16px" },
                        }}
                    >
                        <Icon
                            viewBox="0 0 16 16"
                            boxSize={3.5}
                            sx={{
                                "@media (min-width: 120em)": { width: "18px", height: "18px" },
                            }}
                        >
                            <path
                                fill="currentColor"
                                d="M8 0a8 8 0 110 16A8 8 0 018 0zm.5 4a.5.5 0 00-1 0v4.5H4a.5.5 0 000 1h4a.5.5 0 00.5-.5V4z"
                            />
                        </Icon>
                        <Text>{time}</Text>
                    </HStack>
                </Box>
            </HStack>

            {machines.length > 0 && (
                <Flex
                    wrap="wrap"
                    gap={{ base: 1.5, md: 2 }}
                    sx={{
                        "@media (min-width: 120em)": { gap: "10px" },
                    }}
                >
                    {machines.map((name, i) => (
                        <Tag
                            key={i}
                            size="sm"
                            bg="gray.100"
                            color="gray.700"
                            fontWeight={500}
                            rounded="md"
                            fontSize="xs"
                            px={{ base: 1.5, md: 2 }}
                            sx={{
                                "@media (min-width: 120em)": {
                                    fontSize: "15px",
                                    px: "12px",
                                    py: "4px",
                                    borderRadius: "8px",
                                },
                            }}
                        >
                            {name}
                        </Tag>
                    ))}
                </Flex>
            )}

            <Text
                mt={{ base: 2, md: 2.5 }}
                fontSize="xs"
                color={user.reason ? "gray.500" : "gray.400"}
                isTruncated
                sx={{
                    "@media (min-width: 120em)": { fontSize: "15px" },
                }}
            >
                {user.reason || "User is checking in"}
            </Text>
        </Box>
    );
}

export default UserCard;
